export enum ChatbotMessageType {
  ChatbotAskQuestionRequest = 'ChatbotAskQuestionRequest',
  ChatbotAskQuestionResponse = 'ChatbotAskQuestionResponse',
  ChatbotSendSectionReactionRequest = 'ChatbotSendSectionReactionRequest',
  ChatbotSendReactionRequest = 'ChatbotSendReactionRequest',
  ChatbotGenericMessage = 'ChatbotGenericMessage',
  Chatbot = 'Chatbot'
}
